// extracted by extract-css-chunks-webpack-plugin
module.exports = {"adsBlock":"_7nwiz"};